module.exports = __webpack_public_path__ + "img/right2.bb116a82.svg";